import { createRoutine } from "redux-saga-routines";

const getVideosRoutine = createRoutine("GET_VIDEOS");
export default getVideosRoutine;

export const removeVideoFolderRoutine = createRoutine("REMOVE_VIDEO_FOLDER");
export const addVideoFolderRoutine = createRoutine("ADD_VIDEO_FOLDER");
export const sortVideoFoldersRoutine = createRoutine("SORT_VIDEO_FOLDER");
